<template>
        <a-modal-confirmation
            class="o-delete-resource"
            name="delete-resource"
            @onConfirm="deleteResource"
            @onDecline="closeDlg"
            @onClose="closeDlg"
        >
            <h2>
                {{ $t('app.DeleteResource') }}
            </h2>
            <div v-if="resource && resource.key">
                {{ $t('app.WantDeleteResource').replace("#key#", resource.name ? resource.name : resource.key) }}
            </div>
        </a-modal-confirmation>
</template>

<script>
import AModalConfirmation from '@atoms/a-modal-confirmation'

export default {
    name: 'ODeleteResource',
    components: {
        AModalConfirmation
    },
    props: {
        onDeleteResource: {
            type: Function,
            required: true,
        },
    },
    computed: {
    },
    watch: {
    },
    created() {
    },
    data() {
        return {
            resource: null,
        }
    },
    computed: {
    },
    methods: {
        show(resource) {
            this.resource = resource;
            this.$modal.show('delete-resource')
        },
        closeDlg() {
            this.$modal.hide('delete-resource')
        },
        async deleteResource() {
            this.$modal.hide('delete-resource')
            this.onDeleteResource(this.resource);
        },
    },
}
</script>

<style lang="scss">
@import 'theme';
</style>
